import React from "react"
import TeamLink from "../../components/TeamLink"
import TeamCard from "../../components/TeamCard"
import Header from "../../components/Header"
import Layout from "../../layouts/Layout"
import "../../styles/global.css"

export default function Team2020() {
  return (
    <Layout>
      <Header heading="PCCOE&#38;R ACM STUDENT CHAPTER TEAM 2020"></Header>
      <div className="teams-container">
        <TeamCard
          name="Shubham Mhaske"
          position="Chair"
          source="/super-seniors/shubham-mhaske.png"
        />
        <TeamCard
          name="Dhruvi Patel"
          position="Vice-Chair"
          source="/super-seniors/dhruvi-patel.png"
        />
        <TeamCard
          name="Adtiya Kulkarni"
          position="Web Master"
          source="/super-seniors/aditya-kulkarni.png"
        />
        <TeamCard
          name="Chinmay Gawde"
          position="Co-Webmaster"
          source="/super-seniors/chinmay-gawde.png"
        />
        <TeamCard
          name="Akash Shinde"
          position="Promotional Head"
          source="/super-seniors/akash-shinde.png"
        />
        <TeamCard
          name="Isha Sawant"
          position="Secretary"
          source="/super-seniors/isha-sawant.png"
        />
        <TeamCard
          name="Apoorva Mandhare"
          position="Joint Secretary"
          source="/super-seniors/apoorva-mandhare.png"
        />
        <TeamCard
          name="Shreya Ginivar"
          position="Membership Coordinator"
          source="/super-seniors/shreya-ginivar.png"
        />
        <TeamCard
          name="Kalyani Patil"
          position="Treasurer"
          source="/super-seniors/kalyani-patil.png"
        />
        <TeamCard
          name="Sakshi Chopade"
          position="Joint Treasurer"
          source="/super-seniors/sakshi-chopade.png"
        />
      </div>
      <TeamLink
        url="/teams/2019"
        destination="PCCOE&#38;R ACM STUDENT CHAPTER EX-MEMBERS"
      />
      <div className="seperator"></div>
    </Layout>
  )
}
